<template>
  <div class="user-footer-wrapper">
    <div class="banner-box user-center" v-if="bannerMap" @click="bannerAction">
      <img
        :src="bannerMap.picture"
        v-http2
        v-img-size="'medium'"
        v-img-error
        alt=""
      />
    </div>
    <div class="line" v-if="isLine"></div>
    <div class="down-app-box user-center" v-else>
      <div class="desc-box">
        <img :src="APP_LOGO" alt="" />
        <p class="desc">
          {{ $t('随时随地\\n享受\\n美好食物').replace(/\\n/g, '\n') }}
        </p>
      </div>
      <div class="down-box">
        <div
          class="down-item"
          v-for="(app, index) in appList"
          :key="'app' + index"
          @click="appDownLoad(app)"
        >
          <img :src="app.logo" alt="" />
          <span class="content">{{ app.name }}</span>
        </div>
        <p class="line"></p>
      </div>
    </div>
    <div class="logout-btn" @click="signout">{{ $t('退出登录') }}</div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { downloadPopupShow } from '@/components/DownloadApp/downloadPopup.js';
import APP_LOGO from '@/assets/images/didi/app_logo.png';
import config from '@/config/default';
import { isLine } from '@/utils/os';

export default {
  name: 'PersonalFooter',
  props: {
    bannerMap: Object,
  },
  data() {
    return {
      isLine,
      APP_LOGO,
      appList: config.appList,
    };
  },
  computed: {
    ...mapState('common', ['isH5']),
  },
  methods: {
    downloadPopupShow,
    signout() {
      this.$emit('signout');
    },
    bannerAction() {
      this.$emit('action', { tag: 'banner', ...this.bannerMap });
    },
    appDownLoad(item) {
      this.$trackEvent({
        eventId: 'sailing_c_x_download_app_ck',
        eventLabel: '下载app点击',
        attrs: {
          from: 1,
        },
      });
      if (this.isH5) {
        item.url && window.open(item.url, '_blank');
      } else {
        // 如果是安卓跳转链接
        if (item?.type === 'android') {
          item?.webUrl && window.open(item.webUrl, '_blank');
          return;
        }
        this.downloadPopupShow();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.user-footer-wrapper {
  .user-center {
    margin: 20px 16px 0;
  }
  .banner-box {
    height: 56px;
    background: #d8d8d8;
    border-radius: 4px;
    cursor: pointer;
    overflow: hidden;
  }
  .banner-box img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .down-app-box {
    padding: 12px 0 10px;
    background: #f5f5f7;
    border-radius: 4px;
    overflow: hidden;
  }
  .desc-box {
    padding: 0 12px;
    overflow: hidden;
  }
  .desc-box img {
    float: left;
    margin-right: 8px;
    width: 32px;
    height: 32px;
  }
  .desc {
    font-family: 'Aspira Light';
    font-weight: 200;
    font-size: 12px;
    color: #000000;
    line-height: 16px;
  }
  .down-box {
    position: relative;
    margin-top: 10px;
    display: flex;
  }
  .down-item {
    flex: 1;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-family: 'Aspira Light';
    font-weight: 200;
    font-size: 12px;
    color: #000000;
    cursor: pointer;
  }
  .down-item img {
    margin-right: 4px;
    height: 12px;
  }
  .down-item img,
  .down-item .content {
    display: inline-block;
    vertical-align: middle;
  }
  .line {
    position: absolute;
    top: 5px;
    right: 50%;
    transform: translateX(-50%);
    width: 1px;
    height: 10px;
    background: #e3e3e6;
  }
  .logout-btn {
    margin-top: 32px;
    height: 44px;
    line-height: 43px;
    text-align: center;
    @include font-color();
    font-family: 'Aspira Light';
    font-weight: 200;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    border-top: 1px solid #e3e3e6;
    &:hover {
      background: #f5f5f7;
    }
  }
}
@media screen and (max-width: 768px) {
  .user-footer-wrapper {
    padding-top: rem(32);
    .user-center {
      margin: rem(40) rem(52) 0;
      &:first-child {
        margin-top: 0;
      }
    }
    .banner-box {
      height: rem(108);
      border-radius: rem(8);
      box-shadow: 0 0 4px 0 rgba(54, 60, 77, 0.2);
    }
    .down-app-box {
      padding: rem(18) 0 rem(14);
      border-radius: rem(8);
    }
    .desc-box {
      padding: 0 rem(18);
    }
    .desc-box img {
      margin-right: rem(18);
      width: rem(64);
      height: rem(64);
    }
    .desc {
      font-size: rem(24);
      line-height: rem(30);
    }
    .down-box {
      margin-top: rem(14);
    }
    .down-item {
      height: rem(36);
      line-height: rem(36);
      font-size: rem(22);
    }
    .down-item img {
      margin-right: 4px;
      height: rem(22);
    }
    .line {
      top: rem(9);
      width: rem(1);
      height: rem(20);
    }
    .logout-btn {
      margin-top: rem(64);
      height: rem(128);
      line-height: rem(128);
      font-size: rem(32);
    }
  }
}
</style>